<canvas class="__canvas"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mousewheel)="onMouseWheel($event)"
        #canvas>
</canvas>
